/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Add_Marker_ButtonInputs */

const en_markers_add_marker_button = /** @type {(inputs: Markers_Add_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Marker`)
};

const fr_markers_add_marker_button = /** @type {(inputs: Markers_Add_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un marqueur`)
};

const de_markers_add_marker_button = /** @type {(inputs: Markers_Add_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marker hinzufügen`)
};

const it_markers_add_marker_button = /** @type {(inputs: Markers_Add_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi marcatore`)
};

const ru_markers_add_marker_button = /** @type {(inputs: Markers_Add_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить маркер`)
};

const es_markers_add_marker_button = /** @type {(inputs: Markers_Add_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar marcador`)
};

const zh_cn2_markers_add_marker_button = /** @type {(inputs: Markers_Add_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加标记`)
};

const ja_markers_add_marker_button = /** @type {(inputs: Markers_Add_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーを追加`)
};

const hi_markers_add_marker_button = /** @type {(inputs: Markers_Add_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर जोड़ें`)
};

const pt_pt2_markers_add_marker_button = /** @type {(inputs: Markers_Add_Marker_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar marcador`)
};

/**
* | output |
* | --- |
* | "Add Marker" |
*
* @param {Markers_Add_Marker_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_add_marker_button = /** @type {((inputs?: Markers_Add_Marker_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Add_Marker_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_add_marker_button(inputs)
	if (locale === "de") return de_markers_add_marker_button(inputs)
	if (locale === "it") return it_markers_add_marker_button(inputs)
	if (locale === "ru") return ru_markers_add_marker_button(inputs)
	if (locale === "es") return es_markers_add_marker_button(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_add_marker_button(inputs)
	if (locale === "ja") return ja_markers_add_marker_button(inputs)
	if (locale === "hi") return hi_markers_add_marker_button(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_add_marker_button(inputs)
	return en_markers_add_marker_button(inputs)
});